import React, { FC, useState } from "react";
import { Card, Col, Container, Row, Breadcrumb, Tabs, Tab } from "react-bootstrap";
import CardHeader from "react-bootstrap/CardHeader";
import DocumentTab from "./components/DocumentTab";
import CalendarTab from "./components/CalendarTab";

interface Props { }
const SettingsPage: FC<Props> = ({ }) => {
    const [key, setKey] = useState<string | null>('documents');    

    return (
        <>
            <div className="bg-pattern">
                <Container>
                    <Row>
                        <Breadcrumb>
                            <Breadcrumb.Item active>Configurações</Breadcrumb.Item>
                        </Breadcrumb>
                        <Col lg={{ span: 12 }}>
                            <Card>
                                <CardHeader className={'d-flex'}>
                                    <div className="card-title h5">
                                        Configurações
                                    </div>
                                </CardHeader>
                                <Card.Body>
                                    <Tabs
                                        onSelect={(key) => setKey(key)}
                                    >
                                        <Tab eventKey="documents" title="Documentos">
                                            <DocumentTab />
                                        </Tab>                                        
                                        <Tab eventKey="calendars" title="Agendas">
                                            <CalendarTab />
                                        </Tab>
                                    </Tabs>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
}

export default SettingsPage;